import { ReactNode } from "react";

export type Column<T> = { key: string; label: string; render?: (row: T) => ReactNode };

export default function DataTable<T extends Record<string, unknown>>({ columns, rows }: { columns: Column<T>[]; rows: T[] }) {
  return (
    <div className="overflow-x-auto rounded-[24px] border border-[rgba(15,23,42,0.08)] bg-white shadow-[0_18px_45px_rgba(15,23,42,0.06)]">
      <table className="min-w-full divide-y divide-slate-100 text-sm">
        <thead className="bg-[#F8F4EC]">
          <tr>{columns.map((column) => <th key={column.key} className="px-5 py-4 text-left text-xs font-black uppercase tracking-[0.08em] text-slate-500">{column.label}</th>)}</tr>
        </thead>
        <tbody className="divide-y divide-slate-100">
          {rows.map((row, index) => (
            <tr key={String(row.id ?? index)} className="transition hover:bg-[#FDF9F1]">
              {columns.map((column) => <td key={column.key} className="px-5 py-4 align-middle text-slate-700">{column.render ? column.render(row) : String(row[column.key] ?? "")}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
